














































































































import Vue from 'vue'
import ModalOverlay from '@/common/components/ModalOverlay.vue'
import { TextInput, Checkbox } from '@raksul/kamii-vue'
import { ProductState } from '@/product/types'
import { SkuSize } from '@/product/types'
import { getJsonData } from '@/common/utils/dom'
import { JSON_SELECTOR } from '@/common/constants'

export default Vue.extend({
  components: {
    ModalOverlay,
    TextInput,
    Checkbox
  },
  props: {
    outOfStockSizes: {
      type: Array as () => SkuSize[],
      required: true
    }
  },
  data(): {
    isAgreeToTerms: boolean
    userMail: string
    selectedSizeIds: string[]
    isLoading: boolean
  } {
    return {
      isAgreeToTerms: false,
      userMail: getJsonData(JSON_SELECTOR.CURRENT_USER).email || '',
      selectedSizeIds: [],
      isLoading: false
    }
  },
  computed: {
    storeState(): ProductState {
      return this.$store.state
    },
    emailPattern(): RegExp {
      return /^[^@\s]+@[^@\s]+$/
    },
    isInvalidMail(): boolean {
      return !!this.userMail && !this.emailPattern.test(this.userMail)
    },
    disableConfirm(): boolean {
      return !this.userMail
        || this.isInvalidMail
        || !this.isAgreeToTerms
        || !this.selectedSizeIds.length
    },
    isSelectingAllSizes(): boolean {
      return this.selectedSizeIds.length === this.outOfStockSizes.length
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    confirm() {
      this.$emit(
        'onConfirm',
        {
          skuId: this.storeState.productDetail.sku.id,
          email: this.userMail,
          sizeIds: this.selectedSizeIds
        }
      )
      this.isLoading = true
    },
    isSelected(sizeId: string): boolean {
      return this.selectedSizeIds.includes(sizeId)
    },
    appendSelectedSizeIds(sizeId: string) {
      if (this.selectedSizeIds.includes(sizeId))
        this.selectedSizeIds = this.selectedSizeIds.filter(id => id !== sizeId)
      else this.selectedSizeIds.push(sizeId)
    },
    toggleSelectAll() {
      if (this.isSelectingAllSizes)
        this.selectedSizeIds = []
      else this.selectedSizeIds = this.outOfStockSizes.map(size => size.id)
    }
  }
})
